import { useEffect, useState } from 'react';

export function useToggleDarkMode(isDark: boolean) {
  const [innerIsDark, setIsDark] = useState<boolean>(isDark);

  useEffect(() => {
    if (isDark !== innerIsDark) setIsDark(isDark);
  }, [isDark, innerIsDark]);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', innerIsDark);
  }, [innerIsDark]);

  const toggleDarkMode = () => setIsDark((prev) => !prev);

  return { isDark: innerIsDark, toggleDarkMode };
}
